import { createDomain, sample } from 'effector'
import { FormValues } from '~/entities/Promotion'
import { AxiosErrorType, Promocode } from '~/shared/api'
import { pushFx } from '~/shared/lib/history'
import { logger } from '~/shared/lib/logger'
import { mapMessageErrors } from '~/shared/lib/mapMessageErrors'
import { snackbarEnqueued } from '~/shared/lib/notifications'
import { isString } from '~/shared/lib/utils'

export const domain = createDomain('features.promotions.addPromotion')

export const $defaultValues = domain.createStore<FormValues>({
  code: '',
  title: '',
  expiredAt: '',
  isPromotion: true,
  isActive: true,
  beginningAt: '',
  isFirstContract: false,
  carYearsOfManufacture: [],
  carTypesTransmission: [],
  carTypesFuel: [],
  carCategories: [],
  regionsIds: [],
  carBrandsIds: [],
  carModelsIds: [],
  details: {
    discount_percent: undefined,
    discount_amount: undefined,
    duration_days: undefined,
  },
})

export const createFx = domain.createEffect<
  FormValues,
  Promocode,
  AxiosErrorType
>({
  async handler(attrs: FormValues) {
    const {
      regionsIds,
      carBrandsIds,
      carModelsIds,
      carTypesTransmission,
      carTypesFuel,
      carCategories,
      carRegionsIds,
      ...restAttrs
    } = attrs

    const promotion = new Promocode({
      ...restAttrs,
      carTypesTransmission: (carTypesTransmission || []).map((item) =>
        isString(item) ? item : item.id,
      ),
      carTypesFuel: (carTypesFuel || []).map((item) =>
        isString(item) ? item : item.id,
      ),
      carCategories: (carCategories || []).map((item) =>
        isString(item) ? item : item.label,
      ),
    })

    if (Array.isArray(regionsIds)) promotion.setRegions(regionsIds)
    if (Array.isArray(carBrandsIds)) promotion.setCarBrands(carBrandsIds)
    if (Array.isArray(carModelsIds)) promotion.setCarModels(carModelsIds)
    if (Array.isArray(carRegionsIds)) promotion.setCarRegions(carRegionsIds)

    const result = await promotion.save()
    return result.getModel() as Promocode
  },
})

sample({
  clock: createFx.doneData,
  fn() {
    return {
      message: 'Акция создана',
      variant: 'success' as const,
    }
  },
  target: snackbarEnqueued,
})

sample({
  clock: createFx.failData,
  fn(e) {
    logger.error(e)
    return {
      message: mapMessageErrors(e),
      variant: 'error' as const,
    }
  },
  target: snackbarEnqueued,
})

sample({
  clock: createFx.doneData,
  fn(promotion) {
    return `/promotion/${promotion.getApiId()}`
  },
  target: pushFx,
})

export const formSubmitted = domain.createEvent<FormValues>()
sample({
  clock: formSubmitted,
  target: createFx,
})
